/* unplugin-vue-components disabled */import { render } from "./SuccessChapterView.vue?vue&type=template&id=4d3f4645&scoped=true&ts=true"
import script from "./SuccessChapterView.vue?vue&type=script&lang=ts"
export * from "./SuccessChapterView.vue?vue&type=script&lang=ts"

import "./SuccessChapterView.vue?vue&type=style&index=0&id=4d3f4645&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d3f4645"]])

export default __exports__